import { render } from "./ColumnChart.vue?vue&type=template&id=0a6d2156&scoped=true"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"

import "./ColumnChart.vue?vue&type=style&index=0&id=0a6d2156&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6d2156"]])

export default __exports__